import { useState } from 'react';

import { useGetAddons } from '../../api/getAddons';
import { dictionaryTypes } from '../../types';
import { DictionaryList } from '../DictionaryList';

import { AddonsRow } from './AddonsRow';

export const AddonsList = () => {
  const [viewMode, setViewMode] = useState<dictionaryTypes.ViewMode>('active');
  const { data, isLoading, isFetching, isError, refetch } = useGetAddons({ viewMode });
  const addons = data?.addons ?? [];

  return (
    <DictionaryList
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      onRetry={refetch}
      columnLabel="Add-on"
      errorText="Failed to load add-ons"
      emptyText={viewMode === 'archived' ? 'No archived add-ons' : 'No add-ons'}
      isEmpty={addons.length === 0}
    >
      {addons.map((addon) => (
        <AddonsRow key={addon._id} addon={addon} />
      ))}
    </DictionaryList>
  );
};
